<div
  *ngIf="view$ | async as view"
  [ngClass]="{ shadow: view.isPlaying }"
  class="stream-tile row rounded hover-bg-grey-200 border-top border-md p-3 p-md-0 m-md-2 mb-md-3 d-md-flex flex-md-column-reverse"
>
  <ng-container *ngIf="sportData; else titleOnly">
    <div
      class="col-8 col-md-12 ps-0 p-md-3 scoreboard d-flex flex-column"
      data-test="sport-data-container"
    >
      <div class="scoreboard__top mb-2 mb-md-2 flex-grow-1">
        <h4
          class="scoreboard__header d-flex justify-content-between align-items-baseline mb-2"
        >
          <span
            [ngClass]="{ 'truncate-long': !sportData.subtitle1 }"
            class="scoreboard__header--title me-1 headline font-family-bold text-truncate"
            >{{ sportData.title1 }}</span
          >
          <span
            class="scoreboard__header--subtitle color-500 footnote text-truncate"
            >{{ sportData.subtitle1 }}</span
          >
          <span class="scoreboard__header--score ms-auto text-data">{{
            sportData.score1
          }}</span>
        </h4>
        <h4
          class="scoreboard__header d-flex justify-content-between align-items-baseline"
        >
          <span
            [ngClass]="{ 'truncate-long': !sportData.subtitle2 }"
            class="scoreboard__header--title me-1 headline font-family-bold text-truncate"
            >{{ sportData.title2 }}</span
          >
          <span
            class="scoreboard__header--subtitle color-500 footnote text-truncate"
            >{{ sportData.subtitle2 }}</span
          >
          <span class="scoreboard__header--score ms-auto text-data">{{
            sportData.score2
          }}</span>
        </h4>
      </div>
      <div
        class="scoreboard__bottom d-flex justify-content-between align-items-center"
      >
        <h3 class="scoreboard__header--other footnote m-0">{{
          sportData.other
        }}</h3>
        <h3 class="scoreboard__header--period-time footnote m-0"
          >{{ sportData.period
          }}<span *ngIf="!!sportData.period && !!sportData.time"> &bull; </span
          >{{ sportData.time }}</h3
        >
      </div>
    </div>
  </ng-container>
  <ng-template #titleOnly>
    <div
      class="col-8 col-md-12 ps-0 p-md-3 scoreboard"
      data-test="title-container"
    >
      <div class="scoreboard__top mb-2">
        <h4
          class="scoreboard__header d-flex justify-content-between align-items-baseline mb-2"
        >
          <span
            class="scoreboard__header--title me-1 headline font-family-bold text-truncate"
            >{{ view.title }}</span
          >
        </h4>
      </div>
    </div>
  </ng-template>
  <div class="col-4 col-md-12 p-0 round-on-mobile ratio-4-3-on-mobile">
    <flo-stream-tile-thumbnail
      [props]="streamTileThumbnailProps$ | async"
      [showNameBadge]="!!sportData"
    ></flo-stream-tile-thumbnail>
  </div>
</div>
